<template>
  <div id="flow">
    <variable :strategy-id="strategy.id" :strategy-name="strategy.name" :strategy-version="strategy.version" :strategy-version-status="strategy.versionStatus" @getInitializedData="initStrategyVariables" ref="variable"/>
    <flow-editor ref="flow-editor" :flowData="strategy.flowData" @selectItem="selectNodeItem" @clickCanvas="handleClickCanvas" @changeItems="changeItems" @deleteItems="deleteItems" />
    <start-node-business ref="node-business-1" :if-show="showStartNodeFlag" :node-data="nodeData" @saveNodesData="saveFlowData" />
    <middle-node-business ref="node-business-2" :if-show="showMiddleNodeFlag" :node-data="nodeData" :variables-data="variablesData" @saveNodesData="saveFlowData" />
    <end-node-business ref="node-business-4" :if-show="showEndNodeFlag" :variables-data="variablesData" :node-data="nodeData" @saveNodesData="saveFlowData" />
  </div>
</template>

<script>
import FlowEditor from '@/components/g6/flow-editor'
import Variable from './variable'
import StartNodeBusiness from './start-node-business'
import MiddleNodeBusiness from './middle-node-business'
import EndNodeBusiness from './end-node-business'

export default {
  components: {
    FlowEditor,
    Variable,
    StartNodeBusiness,
    MiddleNodeBusiness,
    EndNodeBusiness
  },
  props: {
    strategy: Object
  },
  data () {
    return {
      currentNodeId: null,
      variablesData: [],
      nodeDatas: [],
      nodeData: {node: {}, business: {}},
      showStartNodeFlag: false,
      showMiddleNodeFlag: false,
      showEndNodeFlag: false
    }
  },
  created () {
  },
  watch: {
    strategy: {
      deep: true,
      handler (value, oldValue) {
      }
    }
  },
  methods: {
    selectNodeItem ({ item, nodes, edges }) {
      this.initNodeItemFlag()
      const nodeType = item.getModel().nodeType
      if (nodeType) {
        if (nodeType === '1') {
          this.showStartNodeFlag = true
        } else if (nodeType === '4') {
          this.showEndNodeFlag = true
        } else {
          this.showMiddleNodeFlag = true
        }
        this.initNodeBusiness(nodeType, { item, nodes, edges })
      }
    },
    handleClickCanvas (item) {
      if (!item) {
        this.initNodeItemFlag()
      }
    },
    initNodeItemFlag () {
      this.showStartNodeFlag = false
      this.showEndNodeFlag = false
      this.showMiddleNodeFlag = false
      this.$refs['node-business-1'].editable = false
      this.$refs['node-business-2'].editable = false
      this.$refs['node-business-4'].editable = false
      this.$refs['node-business-2'].activeMiddleTabName = 'first'
      this.$refs['node-business-2'].codeEditable = false
    },
    getNextItems ({ item, nodes, edges }) {
      const nodeItem = item.getModel()
      const nextEdges = edges.filter(s => s.source.id === item.id).map(s => s.getModel())
      const nextNodes = nodes.filter(s => nextEdges.find(o => o.target === s.id)).map(s => s.getModel())
      nodeItem.nextNodes = nextNodes
      return nodeItem
    },
    updateNodeData (propertyModel) {
      this.$refs['flow-editor'].updateGraphByPropertyModel(propertyModel)
    },
    initNodeBusiness (nodeType, {item, nodes, edges}) {
      // 组织数据
      this.currentNodeId = item.id
      const nodeItem = item.getModel()
      console.info('initNodeBusiness:currentNodeId:', this.currentNodeId)
      this.nodeData.node = nodeItem
      if (item.type === 'node') {
        this.nodeData.node = this.getNextItems({item, nodes, edges})
      }
      if (nodeType === '1') {
        this.nodeData.business = {
          strategyId: this.strategy.id,
          graphicNodeId: item.id,
          nodeCode: nodeItem.code,
          nodeName: nodeItem.name,
          strategyCode: this.strategy.code,
          strategyName: this.strategy.name,
          strategyVersion: this.strategy.version,
          strategyVersionDesc: this.strategy.description,
          inputConfig: '输入参数\n • \n • \n • \n'
        }
      } else if (nodeType === '4') {
        this.nodeData.business = {
          strategyId: this.strategy.id,
          graphicNodeId: item.id,
          nodeCode: nodeItem.code,
          nodeName: nodeItem.name
        }
      } else {
        this.nodeData.business = {
          strategyId: this.strategy.id,
          graphicNodeId: item.id,
          nodeCode: nodeItem.code,
          nodeName: nodeItem.name
        }
      }
    },
    initStrategyVariables (data) {
      this.variablesData = data
    },
    changeItems (editor, ev, flowData) {
      let action = ev.action
      console.info('changeItems', ev)
      console.info('changeItems', editor, action, flowData)
      if (this.checkUserBehaviors(ev, flowData)) {
        editor.executeCommand('undo')
        return
      }
      flowData.nodes.forEach(item => {
        delete item.nextNodes
      })
      let strategy = this.$utils.clone(this.strategy, true)
      strategy.flowData = JSON.stringify(flowData)
      this.updateStrategyData(strategy)
    },
    /**
     * 校验用户行为
     * @param ev
     * @param flowData
     * @returns {boolean}
     */
    checkUserBehaviors (ev, flowData) {
      const nodes = flowData.nodes
      const edges = flowData.edges
      if (!(ev.action === 'add' && ev.item.isEdge)) {
        return false
      }
      let startNode = nodes.find(node => node.code === 'start')
      let endNode = nodes.find(node => node.code === 'end')
      let edge = edges.find(edge => edge.target === startNode.id)
      if (!ev.item.target.isItem) {
        this.$message.warning('无节点分流【target】')
        return true
      }
      if (edge) {
        this.$message.warning('不允许以【开始】节点作为节点分流的【target】')
        return true
      }
      edge = edges.find(edge => edge.source === endNode.id)
      if (edge) {
        this.$message.warning('不允许以【结束】节点作为节点分流的【source】')
        return true
      }
      let filteredEdges = edges.filter(edge => edge.source === startNode.id)
      if (filteredEdges && filteredEdges.length > 1) {
        this.$message.warning('【开始】节点只允许一个节点分流')
        return true
      }
      filteredEdges = edges.filter(edge => edge.source === ev.item.source.id && edge.target === ev.item.target.id)
      if (filteredEdges && filteredEdges.length > 1) {
        this.$message.warning('不允许重复绘制相同节点分流')
        return true
      }
      if (edge) {
        this.$message.warning('将会形成死循环的节点分流')
        return true
      }
      edge = edges.find(edge => edge.source === edge.target)
      if (edge) {
        this.$message.warning('将会形成死循环的节点分流')
        return true
      }
      edge = edges.find(edge => edge.source === ev.item.target.id && edge.target === ev.item.source.id)
      if (edge) {
        this.$message.warning('将会形成死循环的节点分流')
        return true
      }
      let checkEndlessLoopResult = edges.some(edge => this.checkEndlessLoop(startNode.id, endNode.id, edge.source, edge, edges))
      if (checkEndlessLoopResult) {
        this.$message.warning('将会形成死循环的节点分流')
        return true
      }

      return false
    },
    /**
     * 校验死循环节点
     * @param startNodeId
     * @param endNodeId
     * @param source
     * @param currentEdge
     * @param edges
     * @returns {*}
     */
    checkEndlessLoop (startNodeId, endNodeId, source, currentEdge, edges) {
      if (source === currentEdge.target) {
        return true
      }
      let nextEdges = edges.filter(edge => source !== startNodeId && source !== endNodeId && edge.source === currentEdge.target)
      return nextEdges.some(edge => this.checkEndlessLoop(startNodeId, endNodeId, source, edge, edges))
    },
    deleteItems (page) {
      console.info('deleteItems:items:', page.getSelected())
      const self = this
      const items = page.getSelected()
      const item = items.find(s => s.getModel().code === 'start' || s.getModel().code === 'end')
      if (item) {
        self.$message.warning('开始/结束节点不可删除')
        return
      }
      items.forEach(item => {
        self.$confirm(`删除【${item.getModel().code ? item.getModel().code : '分流'}】后不可恢复，请谨慎操作！`, '提示', {type: 'warning'}).then(() => {
          if (item.isNode) {
            this.removeNode(item, page)
          } else {
            this.removeEdge(item, page)
          }
        }).catch(action => {
        })
      })
    },
    async removeNode (node, page) {
      const nodeCode = node.getModel().code
      // 请求后端服务
      try {
        let res = await this.$http.delete(`/strategy-node/${this.strategy.id}/${node.id}/${this.strategy.version}`)
        if (res.code !== '200') {
          this.$message.error(res.message)
          return
        }
        page.remove(node.id)
        node.edges.forEach(edge => {
          page.remove(edge.id)
        })
        this.$message.success(`删除${nodeCode}成功`)
      } catch (ex) {
        console.info(ex)
        this.$message.error(`删除${nodeCode}失败`)
      }
    },
    async removeEdge (edge, page) {
      console.info(edge.getModel())
      const sourceNodeId = edge.getModel().source
      const targetNodeId = edge.getModel().target
      // 请求后端服务
      try {
        console.info(edge.getModel())
        let res = await this.$http.delete(`/strategy-node-diversion/${this.strategy.id}/${sourceNodeId}/${targetNodeId}`)
        if (res.code !== '200') {
          this.$message.error(res.message)
          return
        }
        page.remove(edge.id)
        this.$message.success('删除分流成功')
      } catch (ex) {
        console.info(ex)
        this.$message.error('删除分流失败')
      }
    },
    saveFlowData ({node, business}) {
      console.info('saveFlowData:currentNodeId:', this.currentNodeId)
      if (this.showStartNodeFlag) {
        this.strategy.name = business.strategyName
        this.strategy.description = business.strategyVersionDesc
        this.updateStrategyData(this.strategy)
      }
      if (this.showMiddleNodeFlag) {
        let propertyModel = {}
        if (node.name !== business.nodeName) {
          propertyModel['name'] = business.nodeName
        }
        if (node.code !== business.nodeCode) {
          propertyModel['code'] = business.nodeCode
        }
        let newLabel = `${business.nodeCode}\n${business.nodeName}`
        if (node.label !== newLabel) {
          propertyModel['label'] = newLabel
        }
        if (propertyModel) {
          this.updateNodeData(propertyModel)
        }
      }
    },
    async updateStrategyData (data) {
      console.info('updateStrategyData', data)
      // 请求后端服务
      try {
        let res = await this.$http.put(`/strategy`, data)
        if (res.code !== '200') {
          this.$message.error(res.message)
        }
      } catch (ex) {
        console.info(ex)
        this.$message.error('保存策略失败')
      }
    }
  }
}
</script>
<style lang="scss">
  #flow {
    position: relative;
    overflow-x: auto;
  }
  .drag {
    position: absolute;
    left: 0px;
    width: 200px;
    padding-top: 8px;
    border-right: 1px solid #E6E9ED;
    height: 90%;
    top: 88px;
    border-radius: 2px;
    background: #f3f3f3;
    z-index: 99;
    overflow-y: auto;
  }
  .drag2 {
    position: absolute;
    right: 0px;
    width: 400px;
    padding-top: 8px;
    border-right: 1px solid #E6E9ED;
    height: 100%;
    top: 0px;
    border-radius: 2px;
    background: #f3f3f3;
    z-index: 98;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/decisionTree/flow-chat.vue